(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumina-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lumina-landing').forEach(function(root){
  if(root.dataset.ready==='true') return;
  root.dataset.ready='true';
  var selections=[{color:'Beige',size:''},{color:'Beige',size:''},{color:'Beige',size:''}];
  var activeBundle=root.querySelector('.lumina-bundle.is-selected');
  var drawer=root.querySelector('.lumina-drawer');
  var backdrop=root.querySelector('.lumina-drawer-backdrop');
  var error=root.querySelector('.lumina-form-error');
  var form=root.querySelector('.lumina-reservation-form');
  var lastTrigger=null;
  function publishShopifyEvent(eventName,eventData){
    if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){
      try{
        var publishedEvent=window.Shopify.analytics.publish('lumina:'+eventName,eventData);
        if(publishedEvent&&typeof publishedEvent.catch==='function')publishedEvent.catch(function(){});
        return true;
      }catch(analyticsError){}
    }
    return false;
  }
  function trackEvent(eventName,eventData){
    if(typeof window.gtag==='function'){
      window.gtag('event',eventName,eventData);
    }else{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push(Object.assign({event:eventName},eventData));
    }
    return publishShopifyEvent(eventName,eventData);
  }
  function bundleData(){return {qty:Number(activeBundle.dataset.qty),label:activeBundle.dataset.label,name:activeBundle.dataset.name,price:activeBundle.dataset.price};}
  function syncSelections(){activeBundle.querySelectorAll('.lumina-item-config').forEach(function(row,index){selections[index].color=row.querySelector('.lumina-color').value;selections[index].size=row.querySelector('.lumina-size').value;});}
  function renderConfig(){
    root.querySelectorAll('.lumina-pack-config').forEach(function(box){box.hidden=true;box.innerHTML='';});
    var box=activeBundle.querySelector('.lumina-pack-config');
    box.hidden=false;
    box.appendChild(root.querySelector('[data-lumina-config-template]').content.cloneNode(true));
    var list=box.querySelector('.lumina-item-configs');
    for(var i=0;i<bundleData().qty;i++){
      var row=root.querySelector('[data-lumina-row-template]').content.cloneNode(true);
      var el=row.querySelector('.lumina-item-config');
      el.querySelector('b').textContent='#'+(i+1);
      el.querySelector('.lumina-color').value=selections[i].color;
      el.querySelector('.lumina-size').value=selections[i].size;
      (function(index,node){node.querySelector('.lumina-color').addEventListener('change',function(e){selections[index].color=e.target.value;error.hidden=true;});node.querySelector('.lumina-size').addEventListener('change',function(e){selections[index].size=e.target.value;error.hidden=true;});})(i,el);
      list.appendChild(row);
    }
    root.querySelector('[data-lumina-total]').textContent='S/'+bundleData().price;
  }
  function openDrawer(event){
    syncSelections();
    var data=bundleData();
    var sizesComplete=true;
    for(var i=0;i<data.qty;i++){if(!selections[i].size){sizesComplete=false;break;}}
    if(!sizesComplete){error.textContent=root.dataset.sizeError;error.hidden=false;activeBundle.scrollIntoView({behavior:'smooth',block:'center'});return;}
    error.hidden=true;
    lastTrigger=event&&event.currentTarget?event.currentTarget:document.activeElement;
    trackEvent('add_to_cart',{pack:data.label,quantity:data.qty,value:Number(data.price),currency:'PEN'});
    root.querySelector('[data-lumina-summary-title]').textContent=data.label+' · '+data.name;
    root.querySelector('[data-lumina-summary-price]').textContent='S/'+data.price;
    var list=root.querySelector('[data-lumina-summary-variants]');list.innerHTML='';
    for(var j=0;j<data.qty;j++){var li=document.createElement('li');li.textContent='#'+(j+1)+': '+selections[j].color+' · '+selections[j].size;list.appendChild(li);}
    drawer.inert=false;drawer.classList.add('is-open');backdrop.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';window.requestAnimationFrame(function(){var first=drawer.querySelector('input');if(first)first.focus();});
  }
  function closeDrawer(){drawer.classList.remove('is-open');backdrop.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');drawer.inert=true;document.body.style.overflow='';if(lastTrigger&&typeof lastTrigger.focus==='function')lastTrigger.focus();}
  root.querySelectorAll('.lumina-bundle-select').forEach(function(button){button.addEventListener('click',function(){root.querySelectorAll('.lumina-bundle').forEach(function(bundle){bundle.classList.remove('is-selected');bundle.querySelector('button').setAttribute('aria-pressed','false');});activeBundle=button.closest('.lumina-bundle');activeBundle.classList.add('is-selected');button.setAttribute('aria-pressed','true');error.hidden=true;renderConfig();});});
  root.querySelectorAll('[data-lumina-open]').forEach(function(button){button.addEventListener('click',openDrawer);});
  root.querySelectorAll('[data-lumina-close]').forEach(function(button){button.addEventListener('click',closeDrawer);});
  root.addEventListener('keydown',function(event){if(!drawer.classList.contains('is-open'))return;if(event.key==='Escape'){event.preventDefault();closeDrawer();return;}if(event.key!=='Tab')return;var focusable=Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));if(!focusable.length)return;var first=focusable[0];var last=focusable[focusable.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}});
  root.querySelectorAll('.lumina-thumbs button').forEach(function(button){button.addEventListener('click',function(){var main=root.querySelector('[data-lumina-main-image]');main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=button.dataset.image;main.alt=button.dataset.alt;root.querySelectorAll('.lumina-thumbs button').forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false');});button.classList.add('is-active');button.setAttribute('aria-pressed','true');});});
  form.addEventListener('submit',function(event){event.preventDefault();if(!form.reportValidity())return;syncSelections();var data=bundleData();var variants=[];for(var i=0;i<data.qty;i++)variants.push('#'+(i+1)+': '+selections[i].color+' · '+selections[i].size);var fields=new FormData(form);var text=[root.dataset.waGreeting,data.label+' · '+data.name+' '+variants.join(' '),root.dataset.waPrice+': S/'+data.price,root.dataset.waName+': '+fields.get('name'),root.dataset.waCity+': '+fields.get('city'),root.dataset.waDistrict+': '+fields.get('district'),root.dataset.waDisclaimer].join('\n');var eventData={pack:data.label,quantity:data.qty,value:Number(data.price),currency:'PEN'};var whatsappUrl='https://wa.me/'+root.dataset.whatsapp+'?text='+encodeURIComponent(text);var opened=false;function openWhatsapp(){if(opened)return;opened=true;window.location.assign(whatsappUrl);}if(trackEvent('comprar',eventData)){window.setTimeout(openWhatsapp,80);return;}var publishAttempts=0;var publishTimer=window.setInterval(function(){publishAttempts+=1;if(publishShopifyEvent('comprar',eventData)||publishAttempts>=6){window.clearInterval(publishTimer);openWhatsapp();}},50);});
  renderConfig();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumina-whatsapp-bridge"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lumina-whatsapp-bridge]').forEach(function(root){
  var url='';
  try{url=sessionStorage.getItem('lumina_whatsapp_url')||'';sessionStorage.removeItem('lumina_whatsapp_url');sessionStorage.removeItem('lumina_whatsapp_event');}catch(storageError){}
  var fallback=root.querySelector('[data-lumina-whatsapp-fallback]');
  if(url.indexOf('https://wa.me/51943738444?text=')===0){fallback.href=url;window.setTimeout(function(){window.location.replace(url);},900);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
